const FADE_SIZE = 24;

function buildMask(atLeft, atRight) {
	const leftStop = atLeft ? 'black' : `transparent, rgba(0,0,0,0.15) ${FADE_SIZE * 0.7}px, black ${FADE_SIZE}px`;
	const rightStop = atRight ? 'black' : `black calc(100% - ${FADE_SIZE}px), rgba(0,0,0,0.15) calc(100% - ${FADE_SIZE * 0.7}px), transparent`;

	return `linear-gradient(to right, ${leftStop}, ${rightStop})`;
}

export default {
	mounted(el) {
		const update = () => {
			const atLeft = el.scrollLeft <= 0;
			const atRight = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

			el.style.maskImage = buildMask(atLeft, atRight);
		};

		update();
		el._scrollFadeXHandler = update;
		el.addEventListener('scroll', update, { passive: true });

		el._scrollFadeXObserver = new ResizeObserver(update);
		el._scrollFadeXObserver.observe(el);
	},
	unmounted(el) {
		el.removeEventListener('scroll', el._scrollFadeXHandler);
		if (el._scrollFadeXObserver) {
			el._scrollFadeXObserver.disconnect();
		}
	},
};
